import styled from 'styled-components'

const Wrapper = styled.section`
    padding-top: 1%;
// padding-bottom: 5%;
`
export default Wrapper
